import dayjs from 'dayjs';
import i18n from 'i18next';

import { API_TIME_DEFAULT_FORMAT, normalizeToUTCFormat } from './normalize';

export const API_DATE_REGEX = /^\d{2}\.\d{2}\.\d{4}$/;
const EN_DATE_FORMAT = 'MM/DD/YYYY';

/** Переформатирует дату из серверного DD.MM.YYYY в формат текущей локали */
export const formatDateByLocale = (value: string): string => {
  if (!API_DATE_REGEX.test(value)) {
    return value;
  }

  if (i18n.language?.startsWith('en')) {
    const parsed = dayjs(value, API_TIME_DEFAULT_FORMAT);

    if (parsed.isValid()) {
      return parsed.format(EN_DATE_FORMAT);
    }
  }

  return value;
};

// Date => 28 Авг 2022  15:45
export const toDDMYYYYHHMMFormat = (date: Date): string => {
  const day = date.getDate();

  const year = date.getFullYear();

  const month = date.toLocaleString(i18n.language, { month: 'short' });

  const hours = date.getHours();

  const minutes = date.getMinutes();

  return `${normalizeToUTCFormat(day)} ${month} ${year} ${normalizeToUTCFormat(
    hours
  )}:${normalizeToUTCFormat(minutes)}`;
};

export const toDDMMYYYFormat = (date: Date): string => {
  return dayjs(date).format(API_TIME_DEFAULT_FORMAT);
};
